<template>
  <div id="SolarPlants">
    <Hero class="lift" src="../../../assets/nuosavas-namas-elektrine-slaitiniam-stogui.jpg">
      <Row>
        <Column :lg="7">
          <h1 class="title">
            {{ $t('title') | lineBreak }}
          </h1>
        </Column>
        <Column :lg="5">
          <p>{{ $t('side') }}</p>
        </Column>
      </Row>
    </Hero>

    <SectionHowItWorks />
    <SectionPlantTypes />
    <SectionPriceProcess />
    <SectionEquipment />
    <SectionOptimisedTraditional />
    <SectionGuarantees />
    <SectionRoofDirection />
    <SectionCapacityForYou />
    <SectionDoubleAccounting />
    <!-- <SectionMyths /> -->
    <!-- <SectionManufacturerSolar /> -->
    <!-- <SectionOptimisedSystem :ctaTo="{ name: $route.name, hash: '#FooterContact' }" /> -->
    <!-- <SectionMaintenance /> -->
    <!-- <SectionSupportShort /> -->
  </div>
</template>

<script>
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'
import SectionCapacityForYou from './components/SectionCapacityForYou'
import SectionDoubleAccounting from './components/SectionDoubleAccounting'
import SectionEquipment from './components/SectionEquipment/index.vue'
import SectionGuarantees from 'views/components/SectionGuarantees'
import SectionHowItWorks from 'views/components/SectionHowItWorks'
// import SectionMaintenance from './components/SectionMaintenance'
// import SectionManufacturerSolar from './components/SectionManufacturerSolar'
// import SectionMyths from './components/SectionMyths'
// import SectionOptimisedSystem from 'views/components/SectionOptimisedSystem'
import SectionOptimisedTraditional from 'views/components/SectionOptimisedTraditional'
import SectionPlantTypes from './components/SectionPlantTypes'
import SectionPriceProcess from './components/SectionPriceProcess'
import SectionRoofDirection from './components/SectionRoofDirection'
// import SectionSupportShort from './components/SectionSupportShort'
import { getters } from 'views/utils'

export default {
  mixins: [
    Meta(require('@/assets/social/solar.jpg')),
  ],
  components: {
    Hero,
    SectionCapacityForYou,
    SectionDoubleAccounting,
    SectionHowItWorks,
    // SectionMaintenance,
    // SectionManufacturerSolar,
    // SectionMyths,
    SectionEquipment,
    SectionOptimisedTraditional,
    SectionGuarantees,
    SectionRoofDirection,
    // SectionOptimisedSystem,
    SectionPlantTypes,
    SectionPriceProcess,
    // SectionSupportShort,
  },
  computed: getters(),
}
</script>

<style lang="scss">
#SolarPlants {
  .Hero {
    h1 {
      text-align: left;

    }

    .image img {
      filter: brightness(0.65);
      height: 100%;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "meta": {
      "title": {
        "complement": "Nogrid",
        "inner": "Saulės elektrinės namams",
        "separator": "-"
      }
    },
    "title": "Saulės elektrinės namams",
    "side": "Nogrid komanda jau įrengė daugiau nei 2000+ saulės elektrinių Lietuvoje. Savo patirtimi pasidalinsime su Jumis, kad įsigytumėte tinkamiausią sprendimą, leisiantį maksimaliai taupyti."
  }
}
</i18n>
